import type { Directive } from 'vue'

type RevealOptions = {
  delay?: number
}

const observers = new WeakMap<HTMLElement, IntersectionObserver>()

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export const revealDirective: Directive<HTMLElement, RevealOptions | undefined> = {
  mounted(element, binding) {
    element.classList.add('home-reveal')

    const delay = binding.value?.delay
    if (typeof delay === 'number') {
      element.style.setProperty('--home-reveal-delay', `${delay}ms`)
    }

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      element.classList.add('is-visible')
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          element.classList.add('is-visible')
          observer.unobserve(element)
        }
      },
      {
        rootMargin: '0px 0px -32px 0px',
        threshold: 0.05,
      },
    )

    observers.set(element, observer)
    observer.observe(element)
  },

  unmounted(element) {
    observers.get(element)?.disconnect()
    observers.delete(element)
  },
}
